import React from "react";
import Provide from "./Provide";
// import Counter from "./Counter";

import Carousel from "./Carousel";
import Header from "./Header";
import Rules from "./Rules";

function Homepage() {
  return (
    <div>
      <Header />
      {/* <Carousel /> */}
      {/* <Rules/> */}
      <Provide />

      {/* <Counter /> */}
    </div>
  );
}

export default Homepage;
